import * as constants from "./constants";

export default function(state, action){
    if (!state || action.type == constants.COMPANY_LIST_CLEAR_STORE){

        let oldcompanyList = undefined;
        if(!!state){
            oldcompanyList = state.companyList;
        }

            state = {
                companyListSummury: [],
                companyList: oldcompanyList || [],
                isLoading: false,
                isShouldReload: false
            };

    }

    switch(action.type){
        case constants.COMPANY_LIST_SUMMURY_LOAD_START:
            return {...state, ...{isLoading:true}};
        case constants.COMPANY_LIST_SUMMURY_LOAD_SUCCESS:
            return { ...state, ...{companyListSummury:action.data,isLoading:false}};
        case constants.COMPANY_LIST_SUMMURY_LOAD_FAIL:
            return {...state, ...{isLoading:true,error:action.error}};

        case constants.COMPANY_LIST_LOAD_START:
            return {...state, ...{isLoading:true}};
        case constants.COMPANY_LIST_LOAD_SUCCESS:
            return { ...state, ...{companyList:action.data,isLoading:false}};
        case constants.COMPANY_LIST_LOAD_FAIL:
            return {...state, ...{isLoading:true,error:action.error}};

        case constants.COMPANY_LIST_REMOVE_START:
            return {...state, ...{isLoading:true}};
        case constants.COMPANY_LIST_REMOVE_SUCCESS:
            return { ...state, ...{isLoading:false,isShouldReload:true}};
        case constants.COMPANY_LIST_REMOVE_FAIL:
            return {...state, ...{isLoading:true,error:action.error}};

        default:
            return state;
    }
}
